<template>
  <kst-section items-mode class="mt-5">
    <kst-table input-mode :data="items">
      <b-table-column sortable
        v-slot="{ column, row }"
        field="ItemID"
        :label="DeliveryItemCatalog.Name.Label"
      >
        <kst-output error-off field-only
          :field="column.field" :data="row" :catalog="DeliveryItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Details(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column sortable
        v-slot="{ column, row }"
        field="Packaging"
        :label="DeliveryItemCatalog.Packaging.Label"
      >
        <kst-output error-off field-only
          :field="column.field" :data="row" :catalog="DeliveryItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="Quantity"
        :label="DeliveryCatalog.Quantity.Label"
      >
        <kst-output error-off field-only
          :field="column.field" :data="row" :catalog="DeliveryCatalog"
        />
      </b-table-column>

      <b-table-column sortable
        v-slot="{ column, row }"
        field="Weight"
        :label="DeliveryItemCatalog.Weight.Label"
      >
        <kst-output error-off field-only
          :field="column.field" :data="row" :catalog="DeliveryItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import DeliveryItemCatalog from "../DeliveryItemCatalog.js";
import DeliveryCatalog from "../DeliveryCatalog.js";
import Model from "../DeliveryModel.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    DeliveryItemCatalog: DeliveryItemCatalog,
    DeliveryCatalog: DeliveryCatalog,
    Model: Model
  })
}
</script>